import type { FulfilmentDto } from "../core/api/use-get-fulfilments/FulfilmentDto";

export function mergeFulfilments(
    fulfilments: { [key: string]: FulfilmentDto[] },
    linkableFulfilments: { [key: string]: FulfilmentDto[] },
) {
    const mergedFulfilments: {
        [key: string]: FulfilmentDto[];
    } = {};

    // Merge fulfilments
    for (const key in fulfilments) {
        mergedFulfilments[key] = fulfilments[key];
    }

    // Merge linkableFulfilments
    for (const key in linkableFulfilments) {
        if (mergedFulfilments[key]) {
            mergedFulfilments[key] = mergedFulfilments[key].concat(
                linkableFulfilments[key],
            );
        } else {
            mergedFulfilments[key] = linkableFulfilments[key];
        }
    }

    return mergedFulfilments;
}
